import
{
    Home,
    Charities,
    C_BlogDetails_page,
    Privacy_policy_page,
    Terms_and_Conditions,
    ContactUs,
    Products,
    Products_Details,
    AboutUs
}from "../screens";

export const userRouters = [
{path : "/", element : <Home />},
{path : "/charities", element : <Charities />},
{path : "/BlogDetails_page/:id", element : <C_BlogDetails_page />},
{path : "/Privacy_policy_page/:id", element : <Privacy_policy_page />},
{path : "/Terms_and_Conditions/:id", element : <Terms_and_Conditions />},
{path : "/ContactUs", element : <ContactUs />},
{path : "/Products", element : <Products />},
{path : "/Products_Details/:id", element : <Products_Details />},
{path : "/AboutUs", element : <AboutUs />},


]